import React from 'react';
import { Radio } from 'semantic-ui-react';

export default Radio;
